import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody } from "reactstrap"
import ColdCallForm from "./ColdCallForm"
import { fetchData, FetchPutData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/Loader"

const EditColdCall = () => {
  document.title = "Edit Cold Call | Vintage Infra Equipment Sol PVT LTD"
  const { id } = useParams()

  const [formData, setFormData] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (id) {
      fetchcall()
    }
  }, [id])

  async function fetchcall() {
    const APIData = await fetchData(setLoading, `cold/call/${id}`)
    if (APIData?.success) {
      setFormData(APIData?.data)
    }
  }

  const Navigate = useNavigate()

  const handleSubmit = async () => {
    const APIdata = await FetchPutData(setLoading, "cold/call", id, formData)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Cold call updated Successfully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
      Navigate(-1)
    } else {
      Swal.fire({
        title: "Error updating Cold Call",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb
        title="Cold Calling Management"
        breadcrumbItem="Edit Cold Call"
      />
      <Card>
        <CardBody>
          <ColdCallForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default EditColdCall
